import React from 'react'
import Portal from 'components/Portal'

export const SIGNED_IN_HEADER_PORTAL_ID = 'signed-in-header-portal-id'

export interface ISignedInHeaderPortalProps {
  children: React.ReactNode
}

function SignedInHeaderPortal(props: ISignedInHeaderPortalProps) {
  const { children } = props

  return (
    <Portal id={SIGNED_IN_HEADER_PORTAL_ID}>
      {children}
    </Portal>
  )
}

export default React.memo(SignedInHeaderPortal)
